export default function nav() {
	const body = document.getElementsByTagName('body')[0];
	const base = document.getElementById('nav');
	const trigger = document.getElementById('navToggle');
	const menu = base.querySelector('.nav-primary');
	const activeClass = "is-active-nav-primary";
	trigger.onclick = function() {
		if ( body.classList.contains(activeClass) ) {
			//trigger.innerHTML = "Menu";
			body.classList.remove(activeClass)
		} else {
			//trigger.innerHTML = "Close";
			body.classList.add(activeClass)
		}
	}
}
